import DOMPurify from "dompurify";

export function sanitizeHtml(value) {
  return DOMPurify.sanitize(value == null ? "" : String(value), {
    ADD_ATTR: ["contenteditable", "target"],
  });
}

function updateSafeHtml(el, binding) {
  const sanitized = sanitizeHtml(binding.value);
  if (el.innerHTML !== sanitized) {
    el.innerHTML = sanitized;
  }
}

export const safeHtml = {
  bind: updateSafeHtml,
  update: updateSafeHtml,
};

export const clickOutside = {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      const dropdownEl = vnode.context.appendedDropdown;
      if (
        !(
          el === event.target ||
          el.contains(event.target) ||
          (dropdownEl && dropdownEl.contains(event.target))
        )
      ) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent, true);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent, true);
  },
};
